import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Smartphone, MapPin, User } from 'lucide-react';

const Footer = ({ language }) => {
  const translations = {
    de: {
      contact: 'Kontakt',
      quickLinks: 'Schnellzugriff',
      rights: '© 2026 Martinez IT Systems. Alle Rechte vorbehalten.',
      imageCredits: 'Bildquellen',
      unsplash: 'Unsplash',
      pexels: 'Pexels',
      home: 'Startseite',
      prices: 'Preise',
      privateServices: 'Privatkunden',
      businessServices: 'Unternehmen',
      about: 'Über mich',
      privacy: 'Datenschutz',
      imprint: 'Impressum'
    },
    en: {
      contact: 'Contact',
      quickLinks: 'Quick Links',
      rights: '© 2026 Martinez IT Systems. All rights reserved.',
      imageCredits: 'Image Credits',
      unsplash: 'Unsplash',
      pexels: 'Pexels',
      home: 'Home',
      prices: 'Prices',
      privateServices: 'Private Customers',
      businessServices: 'Businesses',
      about: 'About',
      privacy: 'Privacy',
      imprint: 'Imprint'
    }
  };

  const t = translations[language];

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t dark:border-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ color: '#E53D4A' }}>
              Martinez IT Systems
            </h3>
            <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <div className="flex items-start space-x-2">
                <User className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>Felix Martinez</span>
              </div>
              <div className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0" />
                <span>Georg-Weist-Straße 40<br />93133 Burglengenfeld</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <a href="mailto:kontakt@martinez.systems" className="hover:text-[#E53D4A] transition-colors">
                  kontakt@martinez.systems
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0 mt-0" />
                <a href="tel:094719978600" className="hover:text-[#E53D4A] transition-colors">
                  09471/9978600
                </a>
              </div>
              <div className="flex items-start space-x-2">
                <Smartphone className="h-4 w-4 flex-shrink-0 mt-0" />
                <a href="tel:015569104058" className="hover:text-[#E53D4A] transition-colors">
                  015569/104058
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ color: '#E53D4A' }}>
              {t.quickLinks}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.home}
                </Link>
              </li>
              <li>
                <Link to="/prices" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.prices}
                </Link>
              </li>
              <li>
                <Link to="/private-services" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.privateServices}
                </Link>
              </li>
              <li>
                <Link to="/business-services" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.businessServices}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.about}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.privacy}
                </Link>
              </li>
              <li>
                <Link to="/imprint" className="text-gray-600 dark:text-gray-400 hover:text-[#E53D4A] transition-colors">
                  {t.imprint}
                </Link>
              </li>
            </ul>
          </div>

          {/* Image Credits */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ color: '#E53D4A' }}>
              {t.imageCredits}
            </h3>
            <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
              <p>
                {language === 'de' ? 'Bilder von:' : 'Images from:'}
              </p>
              <ul className="space-y-1">
                <li>
                  <a
                    href="https://unsplash.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#E53D4A] transition-colors"
                  >
                    {t.unsplash}
                  </a>
                </li>
                <li>
                  <a
                    href="https://pexels.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#E53D4A] transition-colors"
                  >
                    {t.pexels}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t dark:border-gray-800 text-center text-sm text-gray-600 dark:text-gray-400">
          {t.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
